import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import MyCases from './pages/MyCases';

function App() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const saved = localStorage.getItem('brainaxis-theme');
    if (saved) setTheme(saved);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('brainaxis-theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(theme === 'dark' ? 'light' : 'dark');

  return (
    <AuthProvider>
      <div className="app">
        <Routes>
          {/* Public landing page */}
          <Route path="/" element={<Home theme={theme} toggleTheme={toggleTheme} />} />

          {/* Hidden login — accessible via direct URL only */}
          <Route path="/login" element={<Login theme={theme} toggleTheme={toggleTheme} />} />

          {/* Legal pages */}
          <Route path="/privacy" element={<Privacy theme={theme} toggleTheme={toggleTheme} />} />
          <Route path="/terms" element={<Terms theme={theme} toggleTheme={toggleTheme} />} />

          {/* Legacy redirects */}
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/research" element={<Navigate to="/" replace />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard theme={theme} toggleTheme={toggleTheme} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/my-cases"
            element={
              <ProtectedRoute>
                <MyCases theme={theme} toggleTheme={toggleTheme} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard theme={theme} toggleTheme={toggleTheme} />
              </AdminRoute>
            }
          />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;
